<template>
    <Dialog v-model:visible="visible" :header="$t('about.title')" class="mx-4 w-full sm:w-96" modal>
        <div class="flex flex-col items-center gap-4 py-2">
            <div class="w-14 h-14 rounded-2xl bg-primary-600/20 flex items-center justify-center">
                <i class="pi pi-server text-primary-500 text-3xl" />
            </div>
            <div class="text-center">
                <div class="font-bold text-xl dark:text-white">ComplyIT Admin</div>
                <div class="text-xs text-slate-400">{{ $t('about.tagline') }}</div>
                <div class="text-sm text-primary-400 mt-2">{{ $t('about.version') }} {{ version }}</div>
            </div>

            <div class="w-full border-t border-slate-200 dark:border-slate-800 pt-4">
                <div class="text-[10px] tracking-widest text-slate-400 mb-3">{{ $t('about.changelog').toUpperCase() }}</div>
                <div class="max-h-56 overflow-y-auto pr-1 flex flex-col gap-4">
                    <div v-for="entry in changelog" :key="entry.version">
                        <div class="flex items-baseline gap-2 mb-1">
                            <span class="text-sm font-semibold text-primary-400">v{{ entry.version }}</span>
                            <span class="text-[11px] text-slate-400">{{ entry.date }}</span>
                        </div>
                        <ul class="flex flex-col gap-1">
                            <li v-for="(item, i) in entry.items" :key="i" class="text-xs text-slate-500 dark:text-slate-300 flex gap-2">
                                <span class="text-primary-500">•</span><span>{{ item }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="w-full border-t border-slate-200 dark:border-slate-800 pt-4 text-center">
                <div class="text-[10px] tracking-widest text-slate-400 mb-1">{{ $t('about.powered_by').toUpperCase() }}</div>
                <div class="text-sm font-semibold dark:text-white">IT TEAM</div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts" setup>
    import { Dialog } from 'primevue'
    import { ref } from 'vue'

    import { CHANGELOG } from '@/libs/changelog'
    import { APP_VERSION } from '@/libs/version'

    const visible = ref(false)
    const version = APP_VERSION
    const changelog = CHANGELOG

    const showDialog = () => { visible.value = true }

    defineExpose({ showDialog })
</script>
